import {
  Children,
  isValidElement,
  type ComponentProps,
  type ReactNode,
} from "react";

/** Keeps Markdown table headers beside their values in narrow task descriptions. */
export function TaskDescriptionTable({ children }: ComponentProps<"table">) {
  const sections = getElements(children);
  const header = sections.find((section) => section.type === "thead");
  const body = sections.find((section) => section.type === "tbody");
  const headings = getElements(
    getElements(header?.props.children)[0]?.props.children,
  );
  const rows = getElements(body?.props.children);
  if (rows.length === 0) {
    return (
      <div className="overflow-x-auto">
        <table>{children}</table>
      </div>
    );
  }
  return (
    <div className="not-prose my-3 grid gap-2 [&_a]:underline">
      {rows.map((row, rowIndex) => (
        <dl
          key={rowIndex}
          className="m-0 grid grid-cols-2 gap-x-3 gap-y-1.5 rounded-md border bg-background p-2.5"
        >
          {getElements(row.props.children).map((cell, columnIndex) => (
            <div
              key={columnIndex}
              className={
                columnIndex === 0 ? "col-span-2 [&_dd]:font-medium" : "min-w-0"
              }
            >
              <dt
                className={
                  columnIndex === 0
                    ? "sr-only"
                    : "text-[10px] font-normal text-muted-foreground"
                }
              >
                {headings[columnIndex]?.props.children}
              </dt>
              <dd className="m-0 break-words text-xs text-foreground">
                {cell.props.children}
              </dd>
            </div>
          ))}
        </dl>
      ))}
    </div>
  );
}

function getElements(children: ReactNode) {
  return Children.toArray(children).filter(
    isValidElement<{ children?: ReactNode }>,
  );
}
